/* Geo Gear Co lake finder search (homepage hero).
   Searches our own lake index (/collections/all?view=ggc-index) instead of
   Shopify search, so results are consistent, typo tolerant and state aware.
   Falls back to Shopify predictive search if the index can't load. */
(function(){
  'use strict';
  var form = document.querySelector('[data-ggc-finder]');
  if (!form || !window.fetch) return;
  var input = form.querySelector('.ggc-finder__input');
  var list = form.querySelector('.ggc-finder__results');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var timer = null, lastQ = '', ctrl = null, seq = 0;

  var styles = [];
  try { styles = JSON.parse(form.getAttribute('data-ggc-styles') || '[]') || []; } catch(e){ styles = []; }

  /* ---------- text helpers ---------- */
  var STATES = {al:'Alabama',ak:'Alaska',az:'Arizona',ar:'Arkansas',ca:'California',co:'Colorado',ct:'Connecticut',de:'Delaware',fl:'Florida',ga:'Georgia',hi:'Hawaii',id:'Idaho',il:'Illinois','in':'Indiana',ia:'Iowa',ks:'Kansas',ky:'Kentucky',la:'Louisiana',me:'Maine',md:'Maryland',ma:'Massachusetts',mi:'Michigan',mn:'Minnesota',ms:'Mississippi',mo:'Missouri',mt:'Montana',ne:'Nebraska',nv:'Nevada',nh:'New Hampshire',nj:'New Jersey',nm:'New Mexico',ny:'New York',nc:'North Carolina',nd:'North Dakota',oh:'Ohio',ok:'Oklahoma',or:'Oregon',pa:'Pennsylvania',ri:'Rhode Island',sc:'South Carolina',sd:'South Dakota',tn:'Tennessee',tx:'Texas',ut:'Utah',vt:'Vermont',va:'Virginia',wa:'Washington',wv:'West Virginia',wi:'Wisconsin',wy:'Wyoming'};
  var ABBR = {}, STATE_NAMES = [];
  Object.keys(STATES).forEach(function(k){ ABBR[STATES[k]] = k.toUpperCase(); STATE_NAMES.push(STATES[k]); });
  STATE_NAMES.sort(function(a, b){ return b.length - a.length; });
  var STOP = {lake:1,lakes:1,the:1,of:1,and:1,a:1,on:1,at:1,in:1,decanter:1,decanters:1,whiskey:1,engraved:1,set:1,custom:1,personalized:1};
  var ALIAS = {saint:'st',mount:'mt',mountain:'mtn',fort:'ft',point:'pt'};

  function norm(s){
    return String(s || '').toLowerCase().replace(/[’']/g, '').replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function words(s){
    return norm(s).split(' ').filter(Boolean).map(function(w){ return ALIAS[w] || w; });
  }
  function edits(a, b, max){
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++){
      cur = [i]; var best = i;
      for (j = 1; j <= b.length; j++){
        var c = a[i-1] === b[j-1] ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j-1] + 1, prev[j-1] + c);
        if (i > 1 && j > 1 && a[i-1] === b[j-2] && a[i-2] === b[j-1]) cur[j] = Math.min(cur[j], prevprev[j-2] + 1);
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return max + 1;
      var prevprev = prev; prev = cur;
    }
    return prev[b.length];
  }

  /* ---------- index ---------- */
  var STYLE_ORDER = ['Classic','Classic 6-sided','Vintage','Modern','Modern 6-sided','Decanter set'];
  var SUFFIX = / *(?:(Modern 6-Sided|Modern|6-Sided|Vintage|Laser) +)?Engraved Whiskey Decanter(?: or Decanter Set)?( Set)?(?: - (6-Sided))? *$/i;
  var GENERIC = /^(classic|modern|minimalist) (lake|6-sided) engraved|^custom logo/i;

  function styleLabel(m){
    var s = (m[1] || '').toLowerCase();
    if (m[2]) return 'Decanter set';
    if (s === 'modern 6-sided') return 'Modern 6-sided';
    if (s === 'modern') return 'Modern';
    if (s === '6-sided' || m[3]) return 'Classic 6-sided';
    if (s === 'vintage') return 'Vintage';
    return 'Classic';
  }
  function buildIndex(items){
    var byKey = {}, lakes = [];
    items.forEach(function(it){
      var title = it[0], handle = it[1], img = it[2];
      if (!title || GENERIC.test(title)) return;
      var m = title.match(SUFFIX);
      if (!m) return;
      var rest = title.slice(0, m.index).trim(), state = '', name = rest;
      for (var i = 0; i < STATE_NAMES.length; i++){
        var st = STATE_NAMES[i];
        if (rest.length > st.length && rest.slice(-st.length - 1) === ' ' + st){
          var n = rest.slice(0, -st.length).trim();
          if (n && !/^lake$/i.test(n)){ state = st; name = n; }
          break;
        }
      }
      name = name.replace(/[ ,/]+$/, '');
      if (!name) return;
      var key = norm(name) + '|' + state;
      var lake = byKey[key];
      if (!lake){
        lake = byKey[key] = {name: name, state: state, abbr: ABBR[state] || '', w: words(name).filter(function(x){ return !STOP[x]; }), sw: words(state), styles: [], img: ''};
        if (!lake.w.length) lake.w = words(name);
        lakes.push(lake);
      }
      var label = styleLabel(m);
      var has = lake.styles.some(function(s){ return s.label === label; });
      if (!has) lake.styles.push({label: label, url: root + 'products/' + handle, img: img ? '/cdn/shop/' + img : ''});
    });
    lakes.forEach(function(l){
      l.styles.sort(function(a, b){ return STYLE_ORDER.indexOf(a.label) - STYLE_ORDER.indexOf(b.label); });
      for (var i = 0; i < l.styles.length; i++){ if (l.styles[i].img){ l.img = l.styles[i].img; break; } }
    });
    return lakes;
  }

  var CACHE_KEY = 'ggc-lake-index-v1', CACHE_MS = 6 * 3600 * 1000, idxPromise = null;
  function idxUrl(p){ return root + 'collections/all?view=ggc-index&page=' + p; }
  function loadIndex(){
    if (idxPromise) return idxPromise;
    try {
      var c = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.t && Date.now() - c.t < CACHE_MS && c.items && c.items.length > 50){
        idxPromise = Promise.resolve(buildIndex(c.items));
        return idxPromise;
      }
    } catch(e){}
    idxPromise = fetch(idxUrl(1), {credentials: 'same-origin'}).then(function(r){ return r.json(); }).then(function(first){
      var reqs = [];
      for (var p = 2; p <= (first.pages || 1); p++) reqs.push(fetch(idxUrl(p), {credentials: 'same-origin'}).then(function(r){ return r.json(); }));
      return Promise.all(reqs).then(function(rest){
        var items = first.items || [];
        rest.forEach(function(d){ items = items.concat(d.items || []); });
        if (items.length < 50) throw new Error('index too small');
        try { localStorage.setItem(CACHE_KEY, JSON.stringify({t: Date.now(), items: items})); } catch(e){}
        return buildIndex(items);
      });
    }).catch(function(err){ idxPromise = null; throw err; });
    return idxPromise;
  }

  /* ---------- matching ---------- */
  function parseQuery(q, noState){
    var n = ' ' + norm(q) + ' ', state = '';
    for (var i = 0; !noState && i < STATE_NAMES.length; i++){
      var s = ' ' + norm(STATE_NAMES[i]) + ' ';
      if (n.indexOf(s) > -1){ state = STATE_NAMES[i]; n = n.replace(s, ' '); break; }
    }
    var toks = n.trim().split(' ').filter(Boolean).map(function(w){ return ALIAS[w] || w; });
    if (!state && !noState){
      for (var j = toks.length - 1; j > 0; j--){
        if (toks[j].length === 2 && STATES[toks[j]]){ state = STATES[toks[j]]; toks.splice(j, 1); break; }
      }
    }
    var name = toks.filter(function(w){ return !STOP[w]; });
    return {state: state, name: name, raw: toks};
  }
  function tokenScore(q, isLast, lakeWords){
    var best = 0;
    for (var i = 0; i < lakeWords.length; i++){
      var w = lakeWords[i];
      if (w === q) return 4;
      if (isLast && q.length >= 2 && w.indexOf(q) === 0) best = Math.max(best, 3);
      else if (!isLast && q.length >= 3 && w.indexOf(q) === 0) best = Math.max(best, 2.5);
      else if (q.length >= 4){
        var max = q.length >= 7 ? 2 : 1;
        if (edits(q, w, max) <= max) best = Math.max(best, 1.5);
        else if (isLast && w.length > q.length && edits(q, w.slice(0, q.length), 1) <= 1) best = Math.max(best, 1);
      }
    }
    return best;
  }
  function scoreLake(l, name){
    var total = 0, fuzzy = false;
    for (var i = 0; i < name.length; i++){
      var s = tokenScore(name[i], i === name.length - 1, l.w);
      if (!s) return null;
      if (s < 2) fuzzy = true;
      total += s;
    }
    if (name.length === l.w.length) total += 1;
    return {s: total, fuzzy: fuzzy};
  }
  function search(lakes, q, noState){
    var pq = parseQuery(q, noState), name = pq.name, state = pq.state, res = [];
    if (!name.length && state){
      // "Lake Michigan", "Lake Washington": the state word is really the lake name
      var named = search(lakes, q, true);
      if (named.items.length) return named;
      lakes.forEach(function(l){ if (l.state === state) res.push({l: l, s: 1}); });
      res.sort(function(a, b){ return a.l.name.localeCompare(b.l.name); });
      return {items: res.map(function(r){ return r.l; }), state: state, stateOnly: true};
    }
    if (!name.length) return {items: [], state: state};
    lakes.forEach(function(l){
      var m = scoreLake(l, name);
      if (m) res.push({l: l, s: m.s + (state && l.state === state ? 2 : 0), fuzzy: m.fuzzy, inState: !state || l.state === state});
    });
    if (state && res.some(function(r){ return r.inState; })) res = res.filter(function(r){ return r.inState; });
    // typo matches only show when nothing matches exactly
    if (res.some(function(r){ return !r.fuzzy; })) res = res.filter(function(r){ return !r.fuzzy; });
    var didYouMean = res.length > 0 && res.every(function(r){ return r.fuzzy; });
    res.sort(function(a, b){ return b.s - a.s || a.l.name.length - b.l.name.length || a.l.name.localeCompare(b.l.name); });
    return {items: res.map(function(r){ return r.l; }), state: state, fuzzy: didYouMean};
  }

  /* ---------- rendering ---------- */
  function close(){ list.hidden = true; list.innerHTML = ''; input.setAttribute('aria-expanded', 'false'); }
  function items(){ return Array.prototype.slice.call(list.querySelectorAll('a')); }
  function el(tag, cls, text){ var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function linkRow(href, text, img, cls, sub, go){
    var li = el('li'); li.setAttribute('role', 'option');
    var a = el('a'); a.href = href;
    if (img){ var im = el('img'); im.src = img; im.alt = ''; im.loading = 'lazy'; a.appendChild(im); }
    var s = el('span', 'ggc-r__t' + (cls ? ' ' + cls : ''), text);
    if (sub) s.appendChild(el('span', 'ggc-r__s', sub));
    a.appendChild(s);
    if (go) a.appendChild(el('span', 'ggc-r__go', go));
    li.appendChild(a); return li;
  }
  function withSize(src, w){ return src ? src.replace(/([?&])width=[0-9]+/, '$1width=' + w) : src; }
  function lakeRow(l){
    var li = el('li', 'ggc-r__lake'); li.setAttribute('role', 'option');
    var main = el('a', 'ggc-r__main'); main.href = l.styles[0].url;
    if (l.img){ var im = el('img'); im.src = withSize(l.img, 88); im.alt = ''; im.loading = 'lazy'; main.appendChild(im); }
    var t = el('span', 'ggc-r__t');
    t.appendChild(el('strong', null, l.name));
    if (l.state) t.appendChild(document.createTextNode(', ' + l.state));
    main.appendChild(t);
    main.appendChild(el('span', 'ggc-r__go', 'See it →'));
    li.appendChild(main);
    if (l.styles.length > 1){
      var chips = el('span', 'ggc-r__chips');
      chips.appendChild(el('span', 'ggc-r__chips-l', 'Styles:'));
      l.styles.forEach(function(s){ var c = el('a', 'ggc-r__chip', s.label); c.href = s.url; chips.appendChild(c); });
      li.appendChild(chips);
    }
    return li;
  }
  function searchAllUrl(q){ return form.action + '?type=product&options%5Bprefix%5D=last&q=' + encodeURIComponent(q); }
  function stateUrl(st){ return root + 'collections/' + norm(st).replace(/ /g, '-') + '-lake-whiskey-decanters'; }
  function fallback(q){
    var li = el('li', 'ggc-r__none');
    li.appendChild(el('strong', null, 'We don’t have a design for "' + q + '" yet, but we can make one.'));
    li.appendChild(document.createTextNode(styles.length ? 'Pick a style. We’ll fill in your lake on the next page and send you a proof before engraving.' : 'Choose a style below and we’ll send you a proof before engraving.'));
    list.appendChild(li);
    styles.forEach(function(st){ list.appendChild(linkRow(st.u + (st.u.indexOf('?') > -1 ? '&' : '?') + 'lake=' + encodeURIComponent(q), st.n, st.i, '', st.s, 'Choose →')); });
  }
  function notYours(){
    if (!styles.length) return;
    var nl = linkRow('#ggc-styles', 'Not your lake? Pick a style and we’ll engrave any lake', '', 'ggc-r__alt');
    nl.firstChild.addEventListener('click', function(){ close(); });
    list.appendChild(nl);
  }
  function open(){ list.hidden = false; input.setAttribute('aria-expanded', 'true'); }
  function renderIndex(q, r){
    list.innerHTML = '';
    if (!r.items.length){ fallback(q); open(); return; }
    var MAX = 8;
    if (r.stateOnly) list.appendChild(el('li', 'ggc-r__hd', r.items.length + ' ' + r.state + ' lakes on file. Type a lake name to narrow it down.'));
    else if (r.fuzzy) list.appendChild(el('li', 'ggc-r__hd', 'No exact match for "' + q + '". Did you mean:'));
    r.items.slice(0, MAX).forEach(function(l){ list.appendChild(lakeRow(l)); });
    if (r.stateOnly) list.appendChild(linkRow(stateUrl(r.state), 'See all ' + r.state + ' lakes', '', 'ggc-r__all'));
    else if (r.items.length > MAX) list.appendChild(el('li', 'ggc-r__hd', '+' + (r.items.length - MAX) + ' more. Add the state to narrow it down, e.g. "' + q + ' MN".'));
    notYours();
    open();
  }
  function renderLoading(){
    list.innerHTML = '';
    list.appendChild(el('li', 'ggc-r__none', 'Looking through our lakes…'));
    open();
  }

  /* ---------- fallback: Shopify predictive search ---------- */
  function relevantProds(q, prods){
    var ws = parseQuery(q).name;
    if (!ws.length) return prods;
    return prods.filter(function(p){
      var t = ' ' + norm(p.title) + ' ';
      return ws.every(function(w){ return t.indexOf(' ' + w) > -1; });
    });
  }
  function predictive(q, opts){
    function grab(titleOnly){
      return fetch(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last' + (titleOnly ? '&resources[options][fields]=title' : ''), opts || {})
        .then(function(r){ return r.json(); })
        .then(function(d){ return relevantProds(q, (d && d.resources && d.resources.results && d.resources.results.products) || []); });
    }
    return grab(true).then(function(a){ return a.length ? a : grab(false); });
  }
  function renderPredictive(q, prods){
    list.innerHTML = '';
    if (!prods.length){ fallback(q); list.appendChild(linkRow(searchAllUrl(q), 'Search all lakes for "' + q + '"', '', 'ggc-r__all')); open(); return; }
    prods.slice(0, 6).forEach(function(p){
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=88';
      list.appendChild(linkRow(p.url, p.title, img));
    });
    list.appendChild(linkRow(searchAllUrl(q), 'See all results for "' + q + '"', '', 'ggc-r__all'));
    notYours();
    open();
  }

  /* ---------- run a query ---------- */
  function run(q, opts){
    var my = ++seq;
    var slow = setTimeout(function(){ if (my === seq) renderLoading(); }, 250);
    return loadIndex().then(function(lakes){
      clearTimeout(slow);
      if (my !== seq) return null;
      var r = search(lakes, q);
      renderIndex(q, r);
      return r;
    }, function(){
      clearTimeout(slow);
      return predictive(q, opts).then(function(prods){
        if (my !== seq) return null;
        renderPredictive(q, prods);
        return {items: prods, predictive: true};
      });
    }).catch(function(){ clearTimeout(slow); return null; });
  }
  function suggest(){
    var q = input.value.trim();
    if (q.length < 2){ lastQ = ''; seq++; close(); return; }
    if (q === lastQ) return;
    lastQ = q;
    if (ctrl && ctrl.abort) ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    run(q, ctrl ? {signal: ctrl.signal} : {});
  }

  input.addEventListener('focus', function(){ loadIndex().catch(function(){}); }, {once: true});
  form.addEventListener('pointerenter', function(){ loadIndex().catch(function(){}); }, {once: true});
  input.addEventListener('input', function(){ clearTimeout(timer); timer = setTimeout(suggest, 150); });
  form.addEventListener('submit', function(e){
    e.preventDefault();
    var q = input.value.trim();
    if (!q){ input.focus(); return; }
    clearTimeout(timer);
    lastQ = q;
    run(q).then(function(r){
      if (!r){ window.location.href = searchAllUrl(q); return; }
      if (!r.predictive && r.items.length === 1 && !r.stateOnly && !r.fuzzy){ window.location.href = r.items[0].styles[0].url; return; }
      var a = items(); if (a.length) a[0].focus();
    });
  });
  input.addEventListener('keydown', function(e){
    if (e.key === 'ArrowDown' && !list.hidden){ var a = items(); if (a.length){ e.preventDefault(); a[0].focus(); } }
    else if (e.key === 'Escape'){ close(); }
  });
  list.addEventListener('keydown', function(e){
    var a = items(), i = a.indexOf(document.activeElement);
    if (e.key === 'ArrowDown'){ e.preventDefault(); if (i < a.length - 1) a[i+1].focus(); }
    else if (e.key === 'ArrowUp'){ e.preventDefault(); if (i > 0) a[i-1].focus(); else input.focus(); }
    else if (e.key === 'Escape'){ close(); input.focus(); }
  });
  document.addEventListener('click', function(e){ if (!form.contains(e.target)) close(); });

  /* Popular lake links: open the preview list instead of the search page */
  document.querySelectorAll('.ggc-finder__popular a').forEach(function(a){
    a.addEventListener('click', function(e){
      var q = (a.textContent || '').split(',')[0].trim();
      if (!q) return;
      e.preventDefault();
      input.value = a.textContent.trim();
      input.focus();
      lastQ = input.value;
      run(input.value);
    });
  });

  /* Rotating placeholder */
  var names = (input.getAttribute('data-ggc-rotate') || '').split(',').map(function(x){ return x.trim(); }).filter(Boolean);
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (names.length > 1 && !reduce){
    var ni = 0;
    setInterval(function(){
      if (document.activeElement === input || input.value) return;
      ni = (ni + 1) % names.length;
      input.setAttribute('placeholder', 'Type your lake to preview it, e.g. ' + names[ni]);
    }, 2600);
  }

  /* for testing in the console */
  window.ggcLakeSearch = {load: loadIndex, search: function(q){ return loadIndex().then(function(l){ return search(l, q); }); }, parse: parseQuery};
})();